function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M99.355 29.2471H19.73C9.63704 29.2471 1.42505 37.4581 1.42505 47.5521V190.96C1.42505 201.053 9.63604 209.265 19.73 209.265H99.355C109.448 209.265 117.66 201.054 117.66 190.96V47.5521C117.66 37.4581 109.448 29.2471 99.355 29.2471ZM106.66 190.96C106.66 194.988 103.383 198.265 99.355 198.265H19.73C15.702 198.265 12.425 194.988 12.425 190.96V47.5521C12.425 43.5241 15.702 40.2471 19.73 40.2471H99.355C103.383 40.2471 106.66 43.5241 106.66 47.5521V190.96Z",
  fill: "black"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M237.121 29.2471H157.496C147.403 29.2471 139.191 37.4581 139.191 47.5521V190.96C139.191 201.053 147.402 209.265 157.496 209.265H237.121C247.214 209.265 255.426 201.054 255.426 190.96V47.5521C255.425 37.4581 247.214 29.2471 237.121 29.2471ZM244.425 190.96C244.425 194.988 241.148 198.265 237.12 198.265H157.495C153.467 198.265 150.19 194.988 150.19 190.96V47.5521C150.19 43.5241 153.467 40.2471 157.495 40.2471H237.12C241.148 40.2471 244.425 43.5241 244.425 47.5521V190.96Z",
  fill: "black"
});

function SvgIconNoldrobe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoldrobe);
export default __webpack_public_path__ + "static/media/icon-noldrobe.e3ef641f067e22e36e567475499d73a3.svg";
export { ForwardRef as ReactComponent };